module.exports = __webpack_public_path__ + "static/media/square-root.7be5dff6.svg";